import React from 'react';
import { styled } from '@compiled/react';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import Link from '@atlassian/jira-common-analytics-v2-wrapped-components/src/link';
import type { Props } from './types';

const NameAndDescriptionCell = ({ scheme, getUrl, onLinkClickHandleAnalytics }: Props) => (
	<CellWrapper>
		<NameText>
			{getUrl != null ? (
				<Link
					href={getUrl(scheme)}
					// @ts-expect-error - TS7006 - Parameter '_' implicitly has an 'any' type. | TS7006 - Parameter 'analyticsEvent' implicitly has an 'any' type.
					onClick={(_, analyticsEvent) => {
						if (onLinkClickHandleAnalytics != null) {
							onLinkClickHandleAnalytics(analyticsEvent);
						}
					}}
				>
					{scheme.name}
				</Link>
			) : (
				<span>{scheme.name}</span>
			)}
		</NameText>
		{scheme.description != null ? <Description>{scheme.description}</Description> : <></>}
	</CellWrapper>
);

export default NameAndDescriptionCell;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const NameText = styled.div({
	display: 'flex',
	alignItems: 'baseline',
	textAlign: 'left',
	fontWeight: 'bold',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Description = styled.small({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	color: token('color.text.subtle', colors.N200),
	margin: token('space.0', '0px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const CellWrapper = styled.div({
	display: 'flex',
	paddingTop: token('space.150', '12px'),
	boxSizing: 'border-box',
	height: token('space.600', '48px'),
	flexDirection: 'column',
});
